export default __webpack_public_path__ + "static/media/cognitive-load-icon.e7a50de8.svg";